export const PAGE_PATHS = {
  ROOT: '/',
  CLIENTS: '/clients',
  MY_PRODUCT: '/my-product',
  CLIENT_PROFILE: {
    PROFILE: 'profile',
    ADDRESS: 'address',
    BILLING: 'billing',
    PRODUCTS: 'products',
  },
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_USER: '/verify-user',
  SETUP: '/setup',
  RESET_PASSWORD: '/reset-password',
  PRINT_LABEL: '/print-label',
  REQUEST: '/request',
  NEW_REQUEST: '/new-request',
  REQUEST_ID: '/request/:id',
  JOB: '/job',
  CREATE_JOB: {
    ROOT: 'create-job',
    INQUIRY: 'inquiry',
    SEARCH_REPORT: 'search-report',
    QUOTE: 'quote',
    ORDER: 'order',
  },
  PRODUCT: '/product',
  PRODUCT_DRAFT: '/product/draft',
};
